import { render, staticRenderFns } from "./UploadOtherMaterialsDialog.vue?vue&type=template&id=36095c4b&scoped=true&"
import script from "./UploadOtherMaterialsDialog.vue?vue&type=script&lang=js&"
export * from "./UploadOtherMaterialsDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadOtherMaterialsDialog.vue?vue&type=style&index=0&id=36095c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36095c4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VDialog,VFileInput,VForm,VIcon,VTextField})
